import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Provider } from "react-redux";
import { dtmStore, persistor } from "./store/dtm";
import { PersistGate } from "redux-persist/integration/react";
import { HashRouter } from "react-router-dom";
import App from "./App";
import ScrollToTop from "./components/shared/Scroll";
import { InitializeCrashReporter } from "@/lib/CrashReporter";
import { PrimeReactProvider } from "primereact/api";
import 'primereact/resources/primereact.css';
import "primereact/resources/themes/lara-light-indigo/theme.css";

InitializeCrashReporter();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(

  <Provider store={dtmStore}>
    <PersistGate loading={null} persistor={persistor}>
      <HashRouter>
        <ScrollToTop />
        <PrimeReactProvider>
          <App />
        </PrimeReactProvider>
      </HashRouter>
    </PersistGate>
  </Provider>

);
